import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';
import { pluralTerm } from '../../../lib/helpers/term.helper';

export const scope = 'app.components.DisqualifiedSessionsList';

export default (termLookup: SportTermLookup) => {
  const sessionTerm = termLookup[SportTerminology.SESSION];
  const fieldTerm = termLookup[SportTerminology.FIELD].toLowerCase();

  return defineMessages({
    heading: {
      id: `${scope}.heading`,
      defaultMessage: `${pluralTerm(sessionTerm)} that cannot be used for this round:`
    },
    overlapsPreviousStage: {
      id: `${scope}.overlapsPreviousStage`,
      defaultMessage: `{slot}{venue} — overlaps the previous stage{clashes}. Turn on "Allow overlapping ${pluralTerm(sessionTerm)}" for this stage to use it.`
    },
    groupDoubleBooked: {
      id: `${scope}.groupDoubleBooked`,
      defaultMessage: '{slot}{venue} — a group is already booked into an overlapping {session}{clashes}'
    },
    warningsHeading: {
      id: `${scope}.warningsHeading`,
      defaultMessage: `${pluralTerm(sessionTerm)} to check — these are still used:`
    },
    sameIceWarning: {
      id: `${scope}.sameIceWarning`,
      defaultMessage: `{slot}{venue} — double-booked on the same ${fieldTerm}{clashes}. Only one can actually run.`
    },
    alreadyAssigned: {
      id: `${scope}.alreadyAssigned`,
      defaultMessage: '{count} {noun} already assigned to an earlier round'
    }
  });
};
